var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.833252C11.616 0.833252 10.7681 1.18444 10.143 1.80956C9.51787 2.43468 9.16668 3.28253 9.16668 4.16658C9.16668 5.05064 9.51787 5.89849 10.143 6.52361C10.7681 7.14873 11.616 7.49992 12.5 7.49992C13.3841 7.49992 14.2319 7.14873 14.857 6.52361C15.4822 5.89849 15.8333 5.05064 15.8333 4.16658C15.8333 3.28253 15.4822 2.43468 14.857 1.80956C14.2319 1.18444 13.3841 0.833252 12.5 0.833252ZM12.5 2.41659C13.4667 2.41659 14.25 3.19992 14.25 4.16658C14.25 5.13325 13.4667 5.91658 12.5 5.91658C12.0359 5.91658 11.5908 5.73221 11.2626 5.40402C10.9344 5.07583 10.75 4.63071 10.75 4.16658C10.75 3.70246 10.9344 3.25734 11.2626 2.92915C11.5908 2.60096 12.0359 2.41659 12.5 2.41659ZM3.33334 3.33325V5.83325H0.833344V7.49992H3.33334V9.99992H5.00001V7.49992H7.50001V5.83325H5.00001V3.33325H3.33334ZM12.5 8.33325C10.275 8.33325 5.83334 9.44158 5.83334 11.6666V14.1666H19.1667V11.6666C19.1667 9.44158 14.725 8.33325 12.5 8.33325ZM12.5 9.91658C14.975 9.91658 17.5833 11.1333 17.5833 11.6666V12.5833H7.41668V11.6666C7.41668 11.1333 10 9.91658 12.5 9.91658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.31bc8c23.svg";
export { ForwardRef as ReactComponent };